module.exports = __webpack_public_path__ + "static/image/company/m/image_sustainable_declaration@3x.ver2_0_2.jpg?a3f6a75f";